import { render, staticRenderFns } from "./CommonLogin.vue?vue&type=template&id=34076ec1"
import script from "./CommonLogin.vue?vue&type=script&lang=js"
export * from "./CommonLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports